"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getChartOptions = exports.makeChartGraph = exports.assignXValue = exports.filterZeroImpactIgnorance = exports.getGroupedData = exports.generateSeries = exports.makeColor = exports.getChartHeight = void 0;
var Highcharts = require("highcharts");
var MAX_CHART_HEIGHT = 100000;
function getChartHeight(numOfBars) {
    var base = 40;
    return Math.min(MAX_CHART_HEIGHT, numOfBars * base + 100);
}
exports.getChartHeight = getChartHeight;
var markerMap = {
    Discovery: "diamond",
    Navigate: "righttriangle",
    Specify: "lefttriangle",
    Manage: "downtriangle"
};
var sortingOptions = {
    Alpha: "alpha",
    AlphaDesc: "alphaDESC",
    Value: "value"
};
function attachResizeObserverToChart() {
    // Assuming you have only one Highchart on the page
    if (Highcharts.charts[0]) {
        var chartElement = Highcharts.charts[0].container.parentNode;
        var resizeObserver = new ResizeObserver(handleSidebarResize);
        resizeObserver.observe(chartElement);
    }
}
function breakDownSeries(seriesData) {
    var breakDownSeries = [];
    seriesData.forEach(function (row) {
        breakDownSeries.push(__assign(__assign({}, row), { ol: row.low, oh: row.high, high: row.base }));
        breakDownSeries.push(__assign(__assign({}, row), { ol: row.low, oh: row.high, low: row.base }));
    });
    return breakDownSeries;
}
function makeColor(colorNum) {
    var hues = [
        0, 20, 30, 40, 50, 60, 80, 120, 160, 190, 210, 230, 260, 290, 330, 360,
    ];
    //hues = [...Array(37).keys()].map(x=>x*10);
    var lights = [60, 50, 50, 50, 50, 50, 50, 55, 50, 55, 67, 77, 73, 67, 60, 60];
    var goldenFrac = 0.5 * (3 - Math.sqrt(5));
    var x = ((colorNum * goldenFrac) % 1.0) * (hues.length - 1);
    //x=colorNum%(hues.length-1); // for point visualisation
    var i = Math.floor(x);
    var f = x % 1.0;
    var hue = (1.0 - f) * hues[i] + f * hues[i + 1];
    var light = (1.0 - f) * lights[i] + f * lights[i + 1];
    return ("hsl( " +
        Math.round(hue * 100) / 100 +
        ", 100%, " +
        Math.round(light * 100) / 100 +
        "% )");
}
exports.makeColor = makeColor;
function returnSortedObject(originalObject, yAxisSort, yAxisKey) {
    var sortedObject = __assign({}, originalObject);
    if (yAxisSort == sortingOptions.Alpha) {
        sortedObject = Object.keys(originalObject)
            .sort()
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    else if (yAxisSort == sortingOptions.AlphaDesc) {
        sortedObject = Object.keys(originalObject)
            .sort(function (a, b) { return b.localeCompare(a); }) // Sort keys in descending order
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    else if (yAxisSort == sortingOptions.Value) {
        sortedObject = Object.keys(originalObject)
            .sort(function (keyA, keyB) {
            var maxValueA = Math.max.apply(Math, originalObject[keyA].map(function (item) { return item[yAxisKey]; }));
            var maxValueB = Math.max.apply(Math, originalObject[keyB].map(function (item) { return item[yAxisKey]; }));
            return maxValueB - maxValueA;
        })
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    return sortedObject;
}
function checkAllowedType(inavImpactType, keyX, keyY) {
    // Check if inavImpactType is Quantitative
    if (inavImpactType === "Qualitative") {
        // Convert keyX and keyY to lowercase and check if they contain 'swing'
        if (keyX.toLowerCase().includes('swing') || keyY.toLowerCase().includes('swing')) {
            return false;
        }
    }
    // Return true if none of the conditions for returning false are met
    return true;
}
function generateSeries(data, xAxis, yAxis, nodesImpactType, settings) {
    var groupByName = data.groupByName, projectColor = data.projectColor;
    var yAxisSort = yAxis['data'][yAxis['selected']]['sort'];
    var yAxisKey = yAxis['data'][yAxis['selected']]['key'];
    var series = [];
    series.push({
        name: "<div style='font-size: 12pt;'><strong>Projects</strong></div>",
        color: "#ffffff00",
        data: {},
        marker: {
            radius: 1,
            symbol: ""
        },
        events: {
            legendItemClick: function (e) {
                e.preventDefault();
            }
        }
    });
    groupByName = returnSortedObject(groupByName, yAxisSort, yAxisKey);
    // Create a series for each project
    Object.entries(groupByName).forEach(function (e, index) {
        var key = e[0], value = e[1];
        console.log(index, nodesImpactType[key], projectColor["key"], value);
        var data = [];
        var xAxisKey = xAxis['data'][xAxis['selected']]['key'];
        var yAxisKey = yAxis['data'][yAxis['selected']]['key'];
        var isAllowed = checkAllowedType(nodesImpactType[key], xAxisKey, yAxisKey);
        if (isAllowed) {
            value.forEach(function (v) {
                var marker = {};
                if (v.DiscoveryGrid) {
                    // Decide whether marker should be filled or empty
                    if (v.Experiments === "No") {
                        (marker["fillColor"] = "#F1F1F711"),
                            (marker["lineWidth"] = 3),
                            (marker["lineColor"] = projectColor[key.replace(/\s\s+/g, "_")]);
                    }
                    marker["symbol"] = markerMap[v.DiscoveryGrid];
                    if (v.impact != 0 && v.ignorance != 0) {
                        data.push({
                            x: v[xAxisKey],
                            // x: v.Swing,
                            y: v[yAxisKey],
                            // y: v.expectedProjectValue,
                            title: v['title'],
                            marker: marker
                        });
                    }
                }
            });
            console.log("color: ", key, projectColor.key);
            series.push({
                name: "<div style='font-weight: normal;'>" + key + "</div>",
                id: index,
                color: projectColor[key.replace(/\s\s+/g, "_")],
                marker: {
                    radius: 16,
                    symbol: "diamond"
                },
                data: data
            });
        }
    });
    // Create a blank line in the legend
    series.push({
        name: "<br></br>",
        color: "#ffffff00",
        data: {},
        marker: {
            radius: 1,
            symbol: ""
        }
    });
    // Create comment about meaning of open symbol
    series.push({
        name: "open symbol: no experiment",
        color: "black",
        data: {},
        marker: {
            radius: 13,
            symbol: "circle",
            fillColor: "#ffffff",
            lineWidth: 3,
            lineColor: "#888888"
        },
        events: {
            legendItemClick: function (e) {
                e.preventDefault();
            }
        }
    });
    // Create a blank line in the legend
    series.push({
        name: "<br></br>",
        color: "#ffffff00",
        data: {},
        marker: {
            radius: 1,
            symbol: ""
        }
    });
    // Create label for Discovery Grid Quadrant marker shape definitions
    series.push({
        name: "<div style='font-size: 12pt'><strong>Discovery Grid Quadrant</strong></div>",
        color: "#ffffff00",
        data: {},
        marker: {
            radius: 1,
            symbol: ""
        },
        // prevent click on this line in the legend
        events: {
            legendItemClick: function (e) {
                e.preventDefault();
            }
        }
    });
    // Create series for definition of the marker shapes
    for (var _i = 0, _a = Object.entries(markerMap); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        series.push({
            name: "<div style='font-weight: normal;'>" + key + "</div>",
            color: "black",
            data: {},
            marker: {
                radius: 13,
                symbol: value,
                fillColor: "#ffffff",
                lineWidth: 1,
                lineColor: "#888888"
            },
            // prevent click on this line in the legend
            events: {
                legendItemClick: function (e) {
                    e.preventDefault();
                }
            }
        });
    }
    return series;
}
exports.generateSeries = generateSeries;
function getGroupedData(tableJSON) {
    var a = tableJSON.sort(function (a, b) { return (a.ValueGIvenSuccess < b.ValueGIvenSuccess ? 1 : -1); });
    var projects = __spreadArray([], (tableJSON.map(function (obj) { return obj.name; })), true).sort();
    var projectColor = {};
    projects.forEach(function (p, index) { return (projectColor[p.replace(/\s\s+/g, "_")] = makeColor(index)); });
    var result = tableJSON.reduce(function (r, _a) {
        var name = _a.name, rest = __rest(_a, ["name"]);
        if (!r[name]) {
            r[name] = { name: name, data: [rest] };
        }
        else {
            r[name].data.push(rest);
        }
        return r;
    }, {});
    var groupBy = function (array, property) {
        return array.reduce(function (grouped, element) {
            var _a;
            return (__assign(__assign({}, grouped), (_a = {}, _a[element[property]] = __spreadArray(__spreadArray([], (grouped[element[property]] || []), true), [element], false), _a)));
        }, {});
    };
    var groupByName = groupBy(tableJSON, "name");
    return { groupByName: groupByName, projectColor: projectColor };
}
exports.getGroupedData = getGroupedData;
function filterZeroImpactIgnorance(dataGot) {
    return dataGot.filter(function (item) { return item.impact > 0 && item.ignorance > 0; });
}
exports.filterZeroImpactIgnorance = filterZeroImpactIgnorance;
function assignXValue(mainSeriesData, siblingSeriesData) {
    var totalBars = mainSeriesData.length;
    mainSeriesData.forEach(function (row, index) {
        row.x = index;
    });
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var positionFix_1 = 0.42;
        mainSeriesData.forEach(function (row, index) {
            for (var _i = 0, siblingSeriesData_1 = siblingSeriesData; _i < siblingSeriesData_1.length; _i++) {
                var sibRow = siblingSeriesData_1[_i];
                if (!sibRow.x && sibRow.name === row.name) {
                    sibRow.x = index + positionFix_1;
                    break;
                }
            }
        });
        siblingSeriesData.filter(function (row) { return !row.x; }).forEach(function (row) {
            var rowCopy = __assign(__assign({}, row), { x: totalBars, y: 0 });
            siblingSeriesData.push(rowCopy);
            row.x = totalBars + positionFix_1;
            totalBars += 1;
        });
    }
    return totalBars;
}
exports.assignXValue = assignXValue;
function sortFunction(a, b) {
    return b.mean - a.mean;
}
function updateChartWidth(chartContainer, chartGot) {
    var containerWidth = chartContainer.clientWidth;
    chartGot.setSize(containerWidth, null);
}
function makeChartGraph(series, xAxis, yAxis, optionsGot) {
    var settings = optionsGot.settings, options = optionsGot.options;
    var highChartsContainer = document.getElementById("chartContainer");
    highChartsContainer.style.height = "100%";
    highChartsContainer.style.width = "100%";
    var xAxisKey = xAxis['data'][xAxis['selected']]['key'];
    var xAxisDisplay = xAxis['data'][xAxis['selected']]['display'];
    var xAxisOptions = JSON.parse(xAxis['data'][xAxis['selected']]['options']);
    var yAxisKey = yAxis['data'][yAxis['selected']]['key'];
    var yAxisDisplay = yAxis['data'][yAxis['selected']]['display'];
    var yAxisOptions = JSON.parse(yAxis['data'][yAxis['selected']]['options']);
    Highcharts.SVGRenderer.prototype.symbols.upperleft = function (x, y, w, h) {
        return [
            "M",
            x + w / 6,
            y + h / 6,
            "L",
            x + w + w / 6,
            y + h / 6,
            "L",
            x + w / 6,
            y + h + h / 6,
            "L",
            x + w / 6,
            y + h / 6,
            "Z",
        ];
    };
    if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.upperleft =
            Highcharts.SVGRenderer.prototype.symbols.upperleft;
    }
    Highcharts.SVGRenderer.prototype.symbols.lowerleft = function (x, y, w, h) {
        return [
            "M",
            x + w / 6,
            y - h / 6,
            "L",
            x + w + w / 6,
            y + h - h / 6,
            "L",
            x + w / 6,
            y + h - h / 6,
            "L",
            x + w / 6,
            y - h / 6,
            "Z",
        ];
    };
    if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.lowerleft =
            Highcharts.SVGRenderer.prototype.symbols.lowerleft;
    }
    Highcharts.SVGRenderer.prototype.symbols.lowerright = function (x, y, w, h) {
        return [
            "M",
            x - w / 6,
            y + h - h / 6,
            "L",
            x + w - w / 6,
            y - h / 6,
            "L",
            x + w - w / 6,
            y + h - h / 6,
            "L",
            x - w / 6,
            y + h - h / 6,
            "Z",
        ];
    };
    if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.lowerright =
            Highcharts.SVGRenderer.prototype.symbols.lowerright;
    }
    Highcharts.SVGRenderer.prototype.symbols.upperright = function (x, y, w, h) {
        return [
            "M",
            x - w / 6,
            y + h / 6,
            "L",
            x + w - w / 6,
            y + h / 6,
            "L",
            x + w - w / 6,
            y + h + h / 6,
            "L",
            x - w / 6,
            y + h / 6,
            "Z",
        ];
    };
    if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.upperright =
            Highcharts.SVGRenderer.prototype.symbols.upperright;
    }
    Highcharts.SVGRenderer.prototype.symbols.righttriangle = function (x, y, w, h) {
        return [
            "M",
            x + 0.2113 * w,
            y,
            "L",
            x + 1.07735 * w,
            y + 0.5 * h,
            "L",
            x + 0.2113 * w,
            y + h,
            "L",
            x + 0.2113 * w,
            y,
            "Z",
        ];
    };
    if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.righttriangle =
            Highcharts.SVGRenderer.prototype.symbols.righttriangle;
    }
    Highcharts.SVGRenderer.prototype.symbols.lefttriangle = function (x, y, w, h) {
        return [
            "M",
            x + 0.788675 * w,
            y,
            "L",
            x + 0.788675 * w,
            y + h,
            "L",
            x - 0.07735 * w,
            y + h / 2,
            "L",
            x + 0.788675 * w,
            y,
            "Z",
        ];
    };
    if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.lefttriangle =
            Highcharts.SVGRenderer.prototype.symbols.lefttriangle;
    }
    Highcharts.SVGRenderer.prototype.symbols.downtriangle = function (x, y, w, h) {
        return [
            "M",
            x,
            y + 0.2113249 * h,
            "L",
            x + w,
            y + 0.2113249 * h,
            "L",
            x + w / 2,
            y + 1.0773503 * h,
            "L",
            x,
            y + 0.2113249 * h,
            "Z",
        ];
    };
    if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.downtriangle =
            Highcharts.SVGRenderer.prototype.symbols.downtriangle;
    }
    var chartGot = Highcharts.chart('chartContainer', {
        chart: __assign({ type: "scatter", plotBackgroundColor: "#F1F1F7", zoomType: "xy" }, options),
        title: {
            text: yAxisDisplay + " vs " + xAxisDisplay + " by Project and Issue",
            // text: "eNPV vs Tornado Factor Swing by Project and Issue",
            align: "center"
        },
        yAxis: {
            gridLineWidth: 2,
            gridLineColor: "#ffffff",
            labels: {
                style: {
                    fontSize: "16px"
                },
                formatter: function () {
                    return Intl.NumberFormat("en-US", yAxisOptions ? yAxisOptions : {}).format(Number(this.value));
                }
            },
            title: {
                text: yAxisDisplay,
                // text: "eNPV ($M)",
                style: {
                    fontSize: "18px",
                    fontWeight: "bold"
                }
            }
        },
        xAxis: {
            // min: 0,
            // max: 82,
            gridLineWidth: 2,
            gridLineColor: "#ffffff",
            labels: {
                style: {
                    fontSize: "16px"
                },
                formatter: function () {
                    return Intl.NumberFormat("en-US", xAxisOptions ? xAxisOptions : {}).format(Number(this.value));
                }
            },
            title: {
                text: xAxisDisplay,
                // text: "Tornado Factor Swing ($M)",
                style: {
                    fontSize: "18px",
                    fontWeight: "bold"
                }
            },
            // tickPositions: [1, 4, 9, 16, 25, 36, 49, 64, 81],
            tickLength: 0,
            lineColor: "#ffffffff"
        },
        legend: {
            layout: "vertical",
            align: "right",
            verticalAlign: "middle",
            itemStyle: {
                fontSize: "15px"
            },
            symbolPadding: 15
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                var xText = typeof this.x === 'number' ? this.x.toFixed(settings.decimals) : this.x;
                var yText = typeof this.y === 'number' ? this.y.toFixed(settings.decimals) : this.y;
                return '<span style="color:' + this.point.color + '">◆</span> ' + this.point.title + '<br>' +
                    ("x: <strong>" + xText + "</strong> <br/> y: <strong>" + yText + "</strong>");
            }
        },
        series: series,
        responsive: {
            rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            enabled: false
                        }
                    }
                }]
        }
    });
    // window.addEventListener('resize', ()=> updateChartWidth(highChartsContainer, chartGot));
    return chartGot;
}
exports.makeChartGraph = makeChartGraph;
function getChartOptions(graph, options, xAxisData, yAxisData) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartInverted = options.chartInverted;
    var legendsEnabled = (options['legendsEnabled'] != false);
    var chartWidth = options['legendsEnabled'] == false ? 400 : 580;
    var marginRight = options['legendsEnabled'] == false ? 0 : 50;
    var marginTop = options['legendsEnabled'] == false ? 70 : 30;
    var mainFilteredData = filterZeroImpactIgnorance(graph.mainRows) || [];
    var siblingFilteredData = filterZeroImpactIgnorance(graph.siblingRows) || [];
    var mainSeriesData = getGroupedData(mainFilteredData);
    var siblingSeriesData = getGroupedData(siblingFilteredData);
    var nodesImpactType = graph.nodesImpactType ? graph.nodesImpactType : [];
    var totalBars = assignXValue(mainFilteredData, siblingFilteredData);
    var chartHeight = getChartHeight(totalBars);
    chartHeight = options['legendsEnabled'] == false ? chartHeight + 70 : 0;
    var series = generateSeries(mainSeriesData, xAxisData, yAxisData, nodesImpactType, settings);
    var drilldown = (graph.mainDrillDown || []).map(function (dd) {
        dd.data = breakDownSeries(dd.data);
        return dd;
    });
    if (siblingFilteredData.length > 0) {
        var siblingSeries = generateSeries(siblingSeriesData, xAxisData, yAxisData, nodesImpactType, settings);
        series = series.concat(siblingSeries);
        drilldown = drilldown.concat(graph.siblingDrillDown.map(function (dd) {
            dd.data = breakDownSeries(dd.data);
            return dd;
        }));
    }
    return {
        series: series,
        customised: true,
        options: {
            height: 600,
            // width: 1000,
            zoomType: 'xy'
        },
        settings: settings
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=issue-analysis.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/issue-analysis/issue-analysis.chart.js